var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSectionIconVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 27.5C2 28.6046 2.89543 29.5 4 29.5H32.4091C33.5137 29.5 34.4091 28.6046 34.4091 27.5V8.5C34.4091 7.39543 33.5137 6.5 32.4091 6.5H4C2.89543 6.5 2 7.39543 2 8.5V27.5Z",
    stroke: "#75593A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7658 12.5953C14.7659 12.0016 13.5 12.7222 13.5 13.8851V22.1149C13.5 23.2778 14.7659 23.9984 15.7658 23.4047L22.6962 19.2898C23.6751 18.7085 23.6751 17.2915 22.6962 16.7102L15.7658 12.5953Z",
    fill: "#75593A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectionIconVideo);
export default __webpack_public_path__ + "static/media/sectionIconVideo.782e24cfd46ae916cea3fa25cf704fa5.svg";
export { ForwardRef as ReactComponent };